// import media files

import Avatar1 from 'assets/images/avatar/avatar-1.jpg';
import Avatar2 from 'assets/images/avatar/avatar-2.jpg';
import Avatar3 from 'assets/images/avatar/avatar-3.jpg';
import Avatar4 from 'assets/images/avatar/avatar-4.jpg';
import Avatar5 from 'assets/images/avatar/avatar-5.jpg';
import Avatar6 from 'assets/images/avatar/avatar-6.jpg';
import Avatar7 from 'assets/images/avatar/avatar-7.jpg';
import Avatar8 from 'assets/images/avatar/avatar-8.jpg';
import Avatar9 from 'assets/images/avatar/avatar-9.jpg';
import Avatar10 from 'assets/images/avatar/avatar-10.jpg';
import Avatar11 from 'assets/images/avatar/avatar-11.jpg';
import Avatar12 from 'assets/images/avatar/avatar-12.jpg';

const OurTeamData = [
	{
		id: 1,
		name: 'Paul Haney',
		designation: 'CEO',
		image: Avatar1
	},
	{
		id: 2,
		name: 'Gail Lanier',
		designation: 'Engineering',
		image: Avatar2
	},
	{
		id: 3,
		name: 'Gail Lanier',
		designation: 'Manager',
		image: Avatar3
	},
	{
		id: 4,
		name: 'Mary Holler',
		designation: 'Sales',
		image: Avatar4
	},
	{
		id: 5,
		name: 'Gilbert Farr',
		designation: 'Oprator',
		image: Avatar5
	},
	{
		id: 6,
		name: 'Charlie Holland',
		designation: 'Designer',
		image: Avatar6
	},
	{
		id: 7,
		name: 'James Butler',
		designation: 'Developer',
		image: Avatar7
	},
	{
		id: 8,
		name: 'Richard Lane',
		designation: 'Insight',
		image: Avatar8
	},
	{
		id: 9,
		name: 'Gail Lanier',
		designation: 'Seo',
		image: Avatar9
	},
	{
		id: 10,
		name: 'Mary Holler',
		designation: 'Content',
		image: Avatar10
	},
	{
		id: 11,
		name: 'Gilbert Farr',
		designation: 'Designer',
		image: Avatar11
	},
	{
		id: 12,
		name: 'James Butler',
		designation: 'Developer',
		image: Avatar12
	}
];

export default OurTeamData;
